import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiX } = FiIcons;

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'true');
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="cookie-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-6 left-6 right-6 md:left-auto md:right-8 md:max-w-md z-[100]"
        >
          <div className="bg-white border border-slate-200 shadow-2xl p-6 relative overflow-hidden">
            {/* Accent Bar */}
            <div className="absolute top-0 left-0 w-full h-1 bg-cyan-500"></div>
            
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-cyan-50 flex items-center justify-center flex-shrink-0">
                <SafeIcon icon={FiShield} className="text-cyan-600 text-xl" />
              </div>
              
              <div className="flex-1">
                <h3 className="text-sm font-bold text-slate-900 mb-2 uppercase tracking-wider">Privacy Preference</h3>
                <p className="text-slate-500 text-xs leading-relaxed mb-6">
                  We use cookies to enhance your experience and analyze our traffic. By clicking "Accept", you consent to our use of cookies. Read our <a href="/privacy-policy" className="text-cyan-600 hover:underline">Privacy Policy</a> for more.
                </p>
                
                <div className="flex gap-3">
                  <button
                    onClick={accept}
                    className="flex-1 py-3 bg-slate-900 text-white text-[10px] font-black uppercase tracking-widest hover:bg-black transition-all"
                  >
                    Accept All
                  </button>
                  <button
                    onClick={() => setShow(false)}
                    className="flex-1 py-3 bg-white border border-slate-200 text-slate-400 text-[10px] font-black uppercase tracking-widest hover:border-slate-400 hover:text-slate-600 transition-all"
                  >
                    Essential Only
                  </button>
                </div>
              </div>

              <button 
                onClick={() => setShow(false)}
                className="text-slate-300 hover:text-slate-600 transition-colors"
                aria-label="Close"
              >
                <SafeIcon icon={FiX} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
